<template>
  <app-page-wrapper-grid v-if="activeVendor" v-scroll-target class="menu-page theme-group-2 menu-wide">
    <div class="menu-page__container">
      <template v-if="showRequireCameraMessage()">
        <MenuMessage :show-alert="true" />
      </template>

      <template v-else-if="showMustScanMessage()">
        <MenuMessage :show-info="true" />
      </template>

      <template v-else>
        <app-banner :message="`${vendorAlias} is currently closed`" :condition="!isOpen" />
        <scan-and-go-messages></scan-and-go-messages>
        <quick-menu-link></quick-menu-link>
        <vendor-title></vendor-title>
        <selected-pickup-time :open-on-mount="openPickupModalParsed" :error-message="errorMessage"></selected-pickup-time>
        <menu-item-attributes-filter></menu-item-attributes-filter>
        <quick-menu-bar></quick-menu-bar>
        <vendor-menu-list></vendor-menu-list>
      </template>
    </div>
  </app-page-wrapper-grid>
</template>

<script>
import VendorMenuList from "./components/menu-list/VendorMenuList";
import AppBanner from "@/components/banner/AppBanner";
import MenuMessage from "./components/menu-message/MenuMessage";
import QuickMenuLink from "./components/quick-menu-link/QuickMenuLink";
import { mapActions, mapGetters } from "vuex";
import SelectedPickupTime from "./SelectedPickupTime";
import ScanAndGoMixin from "@/mixins/scan-and-go.mixin";
import ScanAndGoMessages from "@/components/messages/ScanAndGoMessages";
import QuickMenuBar from "./components/quick-menu-bar/QuickMenuBar";
import VendorTitle from "@/components/vendor/vendor-title/VendorTitle";
import MenuItemAttributesFilter from "../menu/components/menu-list/menu-item/menu-item-attributes/MenuItemAttributesFilter.vue";
import { showToaster, ROUTE_NAMES } from "@/utils";
import pickupTimeMixin from "@/mixins/pickup-time.mixin";

export default {
  name: "Menu",
  components: {
    SelectedPickupTime,
    AppBanner,
    VendorMenuList,
    MenuMessage,
    QuickMenuLink,
    ScanAndGoMessages,
    QuickMenuBar,
    VendorTitle,
    MenuItemAttributesFilter
  },
  mixins: [ScanAndGoMixin, pickupTimeMixin],
  props: {
    openPickupModal: {
      type: String,
      default: "false"
    },
    errorMessage: {},
    errorId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.startClosedVendorsCheck([this.activeVendor]);
    if (this.errorMessage && Object.keys(this.errorMessage).length !== 0) {
      showToaster.call(this, {
        errorMessage: this.errorMessage
      });
    }

    if (this.isOpen && this.activeVendor?.pickupTimeSelectionEnabled && this.isVenueOrderAheadAllowed && !this.selectedPickup) {
      this.showPickupTimeOptions(this.activeVendor.id, null, false, !this.isOfferingsPageAvailable);
    }
  },
  unmounted() {
    this.stopClosedVendorsCheck();
  },
  methods: {
    ...mapActions("vendor", ["startClosedVendorsCheck", "stopClosedVendorsCheck"])
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendor/getActiveVendor",
      isOpen: "vendor/isActiveVendorOpen",
      vendorAlias: "venue/getVendorAliasSingular",
      APIType: "venueSettings/APIType",
      isOfferingsPageAvailable: "vendor/isOfferingsPageAvailable"
    }),
    openPickupModalParsed() {
      return this.openPickupModal === "true";
    }
  },
  watch: {
    errorId: function () {
      // If an error is detected after the initial mount of this component, it wasn't showing
      // an error message because this code was only in the mounted lifecycle.  This will allow
      // the error message to display on the menu page if another error is detected while on this
      // current page.  Also generating an errorId since the errorMessage is the same for repeating errors
      // and was causing the watch to never trigger.
      if (this.errorMessage) {
        if (this.openPickupModal === "true") {
          this.showPickupTimeOptions(this.activeVendor.id, { errorMessage: this.errorMessage });
        } else {
          showToaster.call(this, {
            errorMessage: this.errorMessage
          });
        }
      }
    }
  },
  beforeUpdate: function () {
    if (!this.activeVendor) {
      this.$router.push({
        name: ROUTE_NAMES.VENDOR_PICKER
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@include respond-to-mobile {
  ::v-deep.order-summary {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.menu-page {
  max-width: initial;

  &__container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  &.menu-closed {
    margin-top: 50px;
  }
}
</style>
